import { ZIGGU_API_URL } from '@/app/util/urls.js';
import { useStore } from 'vuex';
import Dutch from '@uppy/locales/lib/nl_NL';
import English from '@uppy/locales/lib/en_US';
import French from '@uppy/locales/lib/fr_FR';
import Portuguese from '@uppy/locales/lib/pt_PT';
import { ROUTES_WITH_SUBDOMAIN_REGEX } from '@/app/data/route_constants.js';

export default function useUppyUpload() {
  const store = useStore();
  const current_profile = store.getters.current_profile;
  const current_local = current_profile.attributes.language;

  const getMetaParams = (uppyparams) => {
    const params = { ...uppyparams };

    if (!params.attachment_category_id) {
      delete params.attachment_category_id;
    }

    // (1) Add 'subdomain' meta param to uniquely identify tenant
    let _subdomain = null;
    const parts = window.location.host.split('.');
    // Assuming VITE_ENV_REVIEW is available, similar to the old component
    const is_review = import.meta.env.VITE_ENV === 'review' && !import.meta.env.IS_LOCAL;
    const is_subdomain = (!is_review && parts.length > 2) || (is_review && parts.length > 3);

    if (is_subdomain) {
      [_subdomain] = parts;
    } else if (ROUTES_WITH_SUBDOMAIN_REGEX.test(window.location.pathname)) {
      const match = window.location.pathname.match(/^\/[^/]+\/([^/]+)/);
      _subdomain = match ? match[1] : null;
    }

    if (_subdomain) {
      params._subdomain = _subdomain || {};
    }

    // (2) Profile impersonation, add '_profile_id' and '_profile_type' meta params
    const _profile_id = sessionStorage.getItem('_profile_id');
    const _profile_type = sessionStorage.getItem('_profile_type');

    if (_profile_id) {
      params._profile_id = _profile_id;
      params._profile_type = _profile_type;
    }

    return params;
  };

  const getHeaders = () => {
    const headers = {
      'X-Referer-SPA': window.location.href,
    };
    const csrf_token = document.cookie
      .split('; ')
      .find((row) => row.startsWith('X-CSRF-Token='))
      .split('=')[1];

    if (csrf_token) {
      headers['X-CSRF-Token'] = csrf_token;
    }

    headers['Accept'] = 'application/json';
    return headers;
  };

  const getEndpoint = (is_template = false) => {
    const namespace = store.getters.namespace;
    return is_template
      ? `${ZIGGU_API_URL}/app/v1/${namespace}/attachment_templates`
      : `${ZIGGU_API_URL}/app/v1/${namespace}/attachments`;
  };

  const getUppyLocale = () => {
    // oxlint-disable-next-line default-case
    switch (current_local) {
      case 'en':
        return English;
      case 'fr':
        return French;
      case 'nl':
        return Dutch;
      case 'pt':
        return Portuguese;
    }
  };

  return {
    getMetaParams,
    getHeaders,
    getEndpoint,
    getUppyLocale,
  };
}
